import { useLocale } from '../../i18n/context'

export default function WordReferenceTrigger({
  onClick,
  visible,
}: {
  onClick: () => void
  visible: boolean
}) {
  const { tr } = useLocale()
  return (
    <button
      onClick={onClick}
      aria-label={tr.wordReference.triggerAriaLabel}
      title={tr.wordReference.triggerTitle}
      aria-hidden={!visible}
      tabIndex={visible ? 0 : -1}
      className="word-ref-trigger"
      style={{
        background: 'none',
        border: '1.5px solid var(--border)',
        borderRadius: 50,
        cursor: visible ? 'pointer' : 'default',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 32,
        height: 32,
        color: 'var(--text-secondary)',
        transition: 'color 0.15s, border-color 0.15s, opacity 0.2s',
        opacity: visible ? 1 : 0,
        visibility: visible ? 'visible' : 'hidden',
        pointerEvents: visible ? 'auto' : 'none',
        flexShrink: 0,
      }}
      onMouseEnter={(e) => {
        if (!visible) return
        ;(e.currentTarget as HTMLButtonElement).style.color = 'var(--accent)'
        ;(e.currentTarget as HTMLButtonElement).style.borderColor = 'var(--accent)'
      }}
      onMouseLeave={(e) => {
        ;(e.currentTarget as HTMLButtonElement).style.color = 'var(--text-secondary)'
        ;(e.currentTarget as HTMLButtonElement).style.borderColor = 'var(--border)'
      }}
    >
      {/* Open book icon */}
      <svg
        width="15"
        height="15"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ display: 'block' }}
      >
        <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" />
        <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" />
      </svg>
    </button>
  )
}
